import categoryService from "app/common/services/categoryService";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { getCategoryData } from "./getCategoryData";

export const getInitialState = () => {
    const params = proNavigator.getParams();
    const { category, initialDomains } = params;
    if (!category) {
        return {
            domains: initialDomains?.split(",")?.map((domain) => ({ domain })) ?? [],
            segments: [],
        };
    }
    const categoryObject = categoryService.categoryQueryParamToCategoryObject(category);

    if (!categoryObject) {
        return {
            country: 999,
            domains: [],
            categoryObject: null,
            segments: [],
        };
    }

    const { domains, country, segments } = getCategoryData(categoryObject);
    return { country, domains, categoryObject, segments };
};
